module.exports = __webpack_public_path__ + "media/images/category/feature/index/index_hero_img_pc-d4262e4f601f0fce768c228d3aa0abba.jpg";